<template>
    <!-- Hide navigation if Portal is being displayed in an Iframe -->
    <div id="divNavigation" v-if="!this.$store.getters.getRenderPagesInIframe">
        <nav>
            <ul id="ulNavMenu" class="menu customer-menu" v-show="showDesktopHeaderAndNavigation || openNav">
                <li v-show="openNav" class="customer-menu-close">
                    <a href="#" @click.prevent="closeNav()"><v-icon name="times" class="icon-2x" /></a>
                </li>
                <router-link tag="li" v-for="link in navigationData" :key="link.Id" :to="`${link.PageLink}`" 
                        v-show="isDesktop || (!isDesktop && link.ShowInMobile)"><a>{{ translateText(link.PageText) }}</a></router-link>
            </ul> 
        </nav>

        <div id="divResponsiveSubHeader" class="customer-responsive-menu col-md-12 col-sm-12 col-xs-12" v-show="!showDesktopHeaderAndNavigation">
            <div id="divMenu" class="div-inline-block">
                <a href="#ulNavMenu" @click.prevent="showNav()" class="responsive-menu-item" aria-label="Show Navigation"><v-icon name="bars" class="icon-2x menu-bars" /></a>
            </div>
            <div id="divPageName" class="div-inline-block">
                <label class="responsive-menu-item text-center" v-text="pageTitle"></label>
            </div>
            <div id="divInformation" class="div-inline-block" v-show="displayHeaderIcon">
                <a href="#mobile-account-information" @click.prevent="showAccountInformation()" class="responsive-menu-item" aria-label="Show Account Information"><v-icon name="user" class="icon-2x account-user" /></a>
            </div>           
        </div>
    </div>       
</template>

<script>
import axios from "axios";

export default {
    name: 'Navigation',
    data() {
        return {
            isDesktop: true,
            openNav: false,
            windowHeight: 0
        }
    },
    mounted() { 
        this.openNav = false;
        var navMenuLinks = this.$store.getters.getNavigationMenuLinks;

        if (navMenuLinks.length === 0) {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Navigation/GetNavigationLinks"
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.$store.commit('setNavigationMenuLinks', response);
                }
            }, error => {
                console.log(error);
            })
        }

        document.body.addEventListener('click', (event) => {
            // Close Nav or Account information based on the target click
            var clickedTarget = event.target;
            if (clickedTarget.nodeName === "path") {
                var nearestElement = clickedTarget.nearestViewportElement;
                if (nearestElement != null && nearestElement.nodeName === "svg") {
                    clickedTarget = nearestElement;
                }
            }

            if (clickedTarget != null && clickedTarget.nodeName === "svg") {
                // Get Class List for svg element - which will have the different classes based on which icon was clicked
                var targetClassList = clickedTarget.classList;

                // Navigation
                if (this.$inArray("menu-bars", targetClassList)) {
                    this.showNav();
                } else {
                    this.closeNav();
                }
                
                // Account Information
                var showAccountInformation = this.$inArray("account-user", targetClassList);
                this.$store.commit('setShowHeaderAccountInformation', showAccountInformation);
            } else {
                this.closeNav();
                this.$store.commit('setShowHeaderAccountInformation', false);
            }
        })
    },
    methods: {
       handleWindowResize(event) {
           this.isDesktop = window.innerWidth > 768;
           this.$store.commit('setIsDesktop', this.isDesktop);
           this.windowHeight = window.outerHeight;
        },
        showNav() {
            this.openNav = true;
        },
        closeNav() {
            this.openNav = false;
        },
        showAccountInformation() {
            this.$store.commit('setShowHeaderAccountInformation', true); 
        },
        translateText(pageText) {
            if (pageText === undefined) {
                return "";
            }

            var languages = this.$i18n.messages;
            var currentLanguage = this.$i18n.locale;
            
            // Check if current language is part of our set up
            if (currentLanguage in languages) {
                // Get all the messages for this language
                var currentLanguageMessages = languages[currentLanguage].message;
                if (currentLanguageMessages !== null && (pageText !== "")) {
                    var languageText = currentLanguageMessages[pageText.replace(/ /g, "").toLowerCase()];
                    return languageText !== undefined ? languageText : pageText;
                }
            }
            
            return pageText;
        }
    },
    created() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();        
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    computed: {
        navigationData() {
            return this.$store.getters.getNavigationMenuLinks;
        },
        pageTitle() {
            return this.$route.name;
        },
        showDesktopHeaderAndNavigation() {
            return this.isDesktop;
        },
        displayHeaderIcon() {
            return this.$store.getters.getDisplayHeaderAccountInformation;
        }
    }
}
</script>

<style scoped>
.router-link-active a {
    text-decoration: none;
}

.customer-menu-close {
    width: 12%;
    margin-left: 88%;
    margin-bottom: 20px;
    background: none;
}

.customer-menu-close a:hover {
    background: none !important;
    border-bottom: 0;
}
</style>
